import { render, staticRenderFns } from "./RiskManager.vue?vue&type=template&id=561fa144&scoped=true&"
import script from "./RiskManager.vue?vue&type=script&lang=js&"
export * from "./RiskManager.vue?vue&type=script&lang=js&"
import style0 from "./RiskManager.vue?vue&type=style&index=0&id=561fa144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fa144",
  null
  
)

export default component.exports